import { render, staticRenderFns } from "./requestList.vue?vue&type=template&id=6de93e6b&scoped=true"
import script from "./requestList.vue?vue&type=script&lang=js"
export * from "./requestList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de93e6b",
  null
  
)

export default component.exports